import styled from "styled-components";

export const ChatbotSelectPatient = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  .header {
    padding: 10px 20px;
    display: flex;
    padding-left: 20px;
    justify-content: space-between;
    align-items: center;
    &__text {
      color: #1f1f52;
      font-size: 25px;
    }
  }
  .patient-list {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    .searcher {
      margin: 0 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #efeff9;
      margin-bottom: 10px;
    }
    .patients {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow-y: scroll;
      padding-left: 20px;
      padding-bottom: 10px;
      .users-list__responses {
        margin: auto;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background-color: #e9e9f5;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .button-select {
      margin-left: 10px;
      width: 100%;
    }
  }
`;

export const PatientItem = styled.div`
  border-radius: 20px;
  background-color: ${({ selected }) => (selected ? "#6C6BF5" : "#f2f2f7")};
  display: flex;
  align-items: center;
  margin: 10px;
  padding: 5px 20px;
  cursor: pointer;
  .img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 5px;
    object-fit: cover;
  }
  .name {
    font-family: "Nunito Sans";
    font-size: 14px;
    color: ${({ selected }) => (selected ? "#FFFFFF" : "#1f1f52")};
  }
  .process {
    font-family: "Nunito Sans";
    font-size: 12px;
    color: ${({ selected }) => (selected ? "#FFFFFF" : "#1f1f52")};
  }
  .email {
    font-family: "Nunito Sans";
    font-size: 12px;
    color: ${({ selected }) => (selected ? "#ffffffa7" : "#1f1f52")};
  }
`;
